import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";
import Loader from '../../../utils/Loader';
import { yupResolver } from "@hookform/resolvers/yup";
import { useShowCourseQuery,useUpdateCourseMutation,useGetQualificationListQuery} from "../../../Services/api";
export default function UpdateStudent(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        cgroup: Yup.string().required("qualification fields is required"),
        course_name: Yup.string().required("course name fields is required"),
        short_name: Yup.string().required("short name fields is required"),
        elements: Yup.string().required("elements  fields is required"),
        course_type: Yup.string().required("course type  fields is required"),
    });
      const {
        data: ShowCourse,
        isLoading: isGetLoading,
      } =  useShowCourseQuery({  params:props['id']});

      const [UpdateCourse,isLoading] = useUpdateCourseMutation();
      const getCourse= ShowCourse?.data[0];
      var  defaultValues={
        cgroup:getCourse?.cgroup,
        course_name:getCourse?.course_name,
        short_name:getCourse?.short_name,
        elements:getCourse?.elements,
        course_type:getCourse?.course_type,
    };
    const methods = useForm({
        mode: "onTouched",
        resolver: yupResolver(validationSchema),
        defaultValues: defaultValues,
      });
      const {
          register,
          handleSubmit,
          reset,
          formState: { errors },
        } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[getCourse]) 

      const updateCourseList = (values,e) => {
        const formData = new FormData();
        formData.append('cgroup', values.cgroup);
        formData.append('course_name', values.course_name);
        formData.append('short_name', values.short_name);
        // formData.append('elements', values.elements);
        formData.append('course_type', values.course_type);
        formData.append('file', values.file[0]);
        formData.append('id', props['id']);
        formData.append('type', 'course');
       
        ///
        UpdateCourse(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    }; 
    
    const { 
        data: getQualificationList        
    } = useGetQualificationListQuery({  params:''});
    if(isGetLoading) return  <Loader></Loader>
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Course</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Course</h5>
                        <form onSubmit={handleSubmit(updateCourseList)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Qualification</label>
                            <div className="col-sm-10">
                               <select  {...register("cgroup",{required:true})} className="form-control" >
                                 <option value="">Select Qualification</option>                                           

                                {                            
                                getQualificationList?.data?.map((item) => {
                                    return (
                                        <option key={item.qid} value={item.qid}>{item.qualification}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                {errors.cgroup && <span  className="text-danger">course group is required</span>}

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">course Name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("course_name",{required:true})} className="form-control" />
                                {errors.course_name && <span  className="text-danger">course name is required</span>}

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">short name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("short_name",{required:true})} className="form-control" />
                                {errors.short_name && <span  className="text-danger">short name is required</span>}

                            </div>
                        </div>
                        {/* <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">short name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("elements",{required:true})} className="form-control" />
                                {errors.elements && <span  className="text-danger">elements is required</span>}

                            </div>
                        </div> */}
                        
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course Type</label>
                            <div className="col-sm-10">
                                <select  {...register("course_type",{required:true})} className="form-control" >
                                 <option value="">Select Type</option>  
                                 <option value="1">paid</option>                                           
                                 <option value="2">free</option>  
                                </select>
                                {errors.course_type && <span  className="text-danger">course type is required</span>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">course image</label>
                            <div className="col-sm-10">
                                <input type="file" {...register("file",{required:true})} className="form-control" />
                                <span className="text-danger">{errors.file?.message}</span>
                                {errors.file && <span  className="text-danger">course image  is required</span>}

                            </div>
                        </div>
                        
                        <div className="modal-footer">
                                
                                {isLoading.status !='pending' ? 
                                 <>
                                    <button type="submit" className="btn btn-warning">Save changes</button>
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                 </>     
                                :
                                <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}